export async function loadTranslation(language = 'nl') {
    if(language.includes('nl')) return await import('./nl.js').then(module => module.onInit)
    if(language.includes('en')) return await import('./en.js').then(module => module.onInit)
    if(language.includes('de')) return await import('./de.js').then(module => module.onInit)
    if(language.includes('fr')) return await import('./fr.js').then(module => module.onInit)
    throw new Error(`Unsupported language: ${language}`)
}